import * as React from 'react';
import {Component, CSSProperties, ReactNode} from 'react';
import * as classNames from 'classnames';
import * as _ from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import {waAction as waLogAction} from '../../../common/wastat';
import {promiseScriptLoader} from '../../../common/promiseScriptLoader';
import {utilLogClick, utilLogOnScreen, utilLogRender, utilLogSdkFinish, utilLogSdkInit} from '../container/store';
import {waitForIdleOrTimeout} from '../../../../common/requestIdleCallback';
import { getAbSlotid } from '../../../common/spacex';

if (process.env.BROWSER) {
  require('./index.less');
}

export interface IGoogleSenseConfig {
  isVisible?: boolean; // 是否 可视化 / 隐藏
  stPos?: string;
  adLayout?: string;
  adFormat?: string;
  adClient: string;
  adSlot: string;
  scriptSrc?: string;
  className?: string; // className for React Component
  style?: CSSProperties; // style for React Component
}

export interface IRussianConfig {
  adSlot: string;
}

export interface IComponentProps {
  type: string;
  isFluid?: boolean;
  config: any;
  scriptSrc: any;
  className?: string;
  style?: CSSProperties;
  isOnScreen?: boolean;
  isTest?: boolean;
  isTakeChance?: boolean;
}
export interface IComponentState {
  hasOnScreen: boolean;
  willShow: boolean;
}

export enum AdType {
  adsense = 'adsense',
  mailRu = 'mailRu',
  dfp = 'dfp',
  ucSdk = 'ucSdk',
  native = 'native',
}

export default class AdComponent extends Component<IComponentProps, IComponentState> {
  private adStartTime: number;
  private loadRenderTimeout: any;
  private loadRenderInterval: any;
  private hasTracked: boolean;

  constructor(props) {
    super(props);
    [
      // 'handleOnLoad',
      'funcAdTimeoutFn',
      'funcAdIFrame',
      'handleClick',
      'handleOnScreen',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
    this.state = {
      hasOnScreen: false,
      willShow: false,
    };
  }

  /**
   * 加载广告的方法
   * @param src 广告的SDK的路径
   * @param type 广告的类型
   * @param cb 回调函数
   */
  public loadSdkScript(src, cb: (startTime: number) => any) {
    const that = this;
    const startTime = Date.now();
    this.adStartTime = Date.now(); // 广告初始化时间
    // native立即执行回调
    if (!src) {
      typeof cb === 'function' && cb(startTime);
      return;
    }
    const afterLoad = function() {
      // sdk加载完打点
      const sdkFinishTime: number = Date.now() - that.adStartTime;
      that.handleSdkFinish(sdkFinishTime);
      // 执行回调
      typeof cb === 'function' && cb(startTime);
    };
    promiseScriptLoader(src).then(afterLoad);
  }

  public switchSdk(item) {
    const { scriptSrc } = this.props;
    this.loadSdkScript(scriptSrc[item.type], () => {
      switch (item.type) {
        case AdType.adsense: {
          ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
          console.log('%c 执行adsense脚本', 'background:#aaa;color:#bada55');
          break;
        }
        case AdType.mailRu: {
          console.log('%c 执行 mailRu 脚本', 'background:#aaa;color:#bada55');
          return !!(window as any).MRGtag.push({});
        }
        case AdType.ucSdk: {
          window.__GETUCPARAMS && window.__GETUCPARAMS.getPageParams({
            'UA': window.navigator.userAgent,
            // 包名：mini browser: com.uc.browser.en，uc browser: ccom.UCMobile.intl
            'pkg': 'com.UCMobile.intl',
            // 页面界面语言（文章语言）（传空，目前俄罗斯没有定向要求）
            'lang': '',
            // 文章id
            'articleId': window._STAT_STORY.item_id,
            // cp的id（传空）
            'cpid': '',
            // 业务类型：机构媒体-0，自媒体-1，3（空军传空，后续可以根据slotid来划分合作流量）
            'media-type': '',
            // 文章频道（传空，目前俄罗斯没有销售单）
            'channel': '',
            // 广告位id
            'slotid': item.adSlot,
            // 业务编号，1-正文页，2-信息流，3-article topbanner，4-Atlas，5-其他
            'ad_slot': 1,
            // 广告是否需要插iframe，若是无网络地址的本地页则需要
            'ifr': 0,
          });
          break;
        }
        case AdType.dfp: {
          const googletag = (window as any).googletag || {};
          googletag.cmd = googletag.cmd || [];
          googletag.cmd.push(function() {
            googletag.defineSlot('/21699147851/Article/Browser_Article_TH_bottom_300X250', [300, 250], 'div-gpt-ad-1544784176927-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
          });
          googletag.cmd.push(function() { googletag.display('div-gpt-ad-1544784176927-0'); });
          console.log('%c 执行 dfp 脚本', 'background:#aaa;color:#bada55');
          break;
        }
        case AdType.native: {
          this.nativeRender();
          if (!(window as any).isInitNative) {
            document.addEventListener('native_ad:change', function(event: any) {
              console.log('监听native事件');
              try {
                if (event.data.id) {
                  const $obj: any = document.querySelectorAll(`#${event.data.id}`)[0];
                  if (event.data.height === '0px') {
                    $obj.remove();
                    console.log(`%c 成功回调,获取高度失败, id为${event.data.id}`, 'background:orange;color:#fff');
                  } else {
                    $obj.style.opacity = 1;
                    $obj.style.height = event.data.height;
                    console.log(`%c 成功回调,获取高度成功, id为${event.data.id}`, 'background:green;color:#fff');
                  }
                } else {
                  // alert('没有回调id')
                  console.warn('没有回调ID');
                }
              } catch (e) {
               console.log(`Native-Error: ${e}`);
              }
            });
            (window as any).isInitNative = true;
            console.log('%c 执行 native 脚本', 'background:#aaa;color:#bada55');
          }
          break;
        }
        default:
          break;
      }
      // iframe 渲染时间打点
      clearTimeout(this.loadRenderTimeout);
      this.loadRenderTimeout = setTimeout(this.funcAdTimeoutFn, 100);
    });
  }

  public renderAdHTML(adConfig): ReactNode {
    const style: CSSProperties = {
          display: 'block',
          textAlign: 'center',
          margin: '0px auto',
          width: '300px',
        };
    let html = <></>;
    switch (adConfig.type) {
      case AdType.adsense: {
        html = <ins className={ 'adsbygoogle' }
          style = { this.props.isFluid ? {minHeight: '120px', display: 'block', borderBottom: '1px solid #e9e9ea'} : _.merge({}, style, {
            height: '250px',
          }) }
          data-ad-format={ this.props.isFluid ? 'fluid' : '' }
          data-ad-layout-key={ this.props.isFluid ? '-fl+5a+1j-ef+k4' : '' }
          data-ad-client={ adConfig.adClient }
          data-ad-slot={ adConfig.adSlot }
        />;
        console.log('%c adsense html返回成功', 'background:green;color:#fff');
        return html;
      }
      case AdType.mailRu: {
        html = <ins style={ style } className="mrg-tag"
        data-ad-slot={ adConfig.adSlot } data-ad-client={adConfig.adClient}></ins>;
        console.log('%c mailRu html返回成功', 'background:green;color:#fff');
        return html;
      }
      case AdType.ucSdk: {
        // @ts-ignore
        html = <interins style={ style } ad_id={ adConfig.adSlot }></interins>;
        console.log('%c ucSdk html返回成功', 'background:green;color:#fff');
        return html;
      }
      case AdType.dfp: {
        html = <div id={adConfig.adSlot} style={{ height: 250, width: 300, margin: '0 auto' }}></div>;
        console.log('%c dfp html返回成功', 'background:green;color:#fff');
        return html;
      }
      case AdType.native: {
        html = <object id={`native-${adConfig.adSlot}`} type="application/view" style={{width: '100%', opacity: 0, height: 0}}>
                <param name="native_type" value="iflow_ad" />
                <param name="channel" value="" />
                <param name="articleid" value="" />
                <param name="cpid" value="" />
                <param name="slotid" value={adConfig.adSlot} />
                <param name="is_use_cache" value="true" />
              </object>;
        console.log('%c native html返回成功', 'background:green;color:#fff');
        return html;
      }
      default:
        break;
    }
  }

  public funcAdTimeoutFn(): void {
    const { config, type } = this.props;
    const adConfig = config[type];
    const iframeList: any = document.querySelectorAll(`#a-d-${adConfig.adSlot} iframe`);
    if (iframeList === undefined || iframeList === null || iframeList.length === 0) {
      this.loadRenderTimeout = setTimeout(this.funcAdTimeoutFn, 100);
      return ;
    }
    const iframe: any = iframeList[0];
    // 判断iframe内容是否加载完
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', this.funcAdIFrame);
    } else {
      iframe.addEventListener('load', this.funcAdIFrame);
    }
  }

  public funcAdIFrame(): void {
    // TODO: 广告渲染耗时打点 (顺序 3)
    // console.log(`3. 广告渲染耗时打点`);
    const { config, type } = this.props;
    const adConfig = config[type];
    const renderTime: number = Date.now() - this.adStartTime;
    // if (this.props.onRender) {
    this.handleRender(renderTime);
    // }
    const iframeList: any = document.querySelectorAll(`#a-d-${adConfig.adSlot} iframe`);
    if (iframeList === undefined || iframeList === null || iframeList.length === 0) { return ; }
    const iframe: any = iframeList[0];
    this.loadRenderInterval = setInterval(() => {
      const activeElement: any = document.activeElement;
      if (activeElement !== undefined
        && activeElement !== null
        && iframe === activeElement
        && this.hasTracked === false
      ) {
        // TODO: 广告点击打点 (顺序 5)
        // console.log(`5. 广告点击打点`);
        this.handleClick();
        this.hasTracked = true;
      }
    }, 200);
  }

  public handleSdkInit(): void {
    const {config, type} = this.props;
    utilLogSdkInit(config[type]);
  }

  public handleSdkFinish(costTime: number): void {
    const {config, type} = this.props;
    utilLogSdkFinish(config[type], costTime);
  }

  public handleRender(costTime: number): void {
    const {config, type} = this.props;
    utilLogRender(config[type], costTime);
  }

  public nativeRender(): void {
    const {config, type} = this.props;
    const renderTime = +new Date() - this.adStartTime;
    utilLogRender(config[type], renderTime || 0);
    console.log('执行native打点成功');
  }

  public handleClick(): void {
    const {config, type} = this.props;
    utilLogClick(config[type]);
  }

  public handleOnScreen = (isVisible: boolean): void => {
    const { config, type } = this.props;
    const adConfig = config[type];
    const { hasOnScreen } = this.state;
    if (hasOnScreen === true) { return ; }
    if (isVisible !== true) { return ; }
    this.setState({
      hasOnScreen: true,
    });
    utilLogOnScreen(adConfig);
  }

  public async componentDidMount() {
    const { config, type } = this.props;
    const adConfig = config[type]; // 结果是数组
    if (!adConfig) {
      return;
    }

    getAbSlotid({
      'header': 'header',
      'footer': 'bottom',
      'article': 'webpreload'
    }[this.props.type], (slotid)=>{
      if(adConfig.type == 'native'){
        adConfig.adSlot = slotid || adConfig.adSlot
      }
    });

    await waitForIdleOrTimeout(500);
    this.hasTracked = false;
    this.setState({willShow: true}, () => {
      try {
        const bucket = adConfig.bucket;
        if (config.isTest && process.env.BROWSER) {
          console.log(`位置: ${type}
        \n广告ID：${adConfig.adSlot}
        \n广告类型: ${adConfig.type}
        \n灰度用户的机率:${config.userHash % 256 / 256}
        \n灰度机率: ${adConfig.chance * 100}%
        \n是否灰度用户：${adConfig.chance ? config.userHash % 256 / 256 <= adConfig.chance : false}
        \n分配的桶：${bucket}
        `);
        }
        process.env.BROWSER && waLogAction({
          ac_name: 'adVisit',
          ac_type: type,
          adpf: 'js',
          adslot: adConfig.adSlot,
          adid: adConfig.adClient,
          adtype: adConfig.type,
          userHash: config.userHash,
          bucketHash: config.bucketHash,
          chance: adConfig.chance,
          bucket,
          isUserTakeChance: adConfig.chance ? config.userHash % 256 / 256 <= adConfig.chance : false,
          userDistributeToBuckets: config.bucketHash % bucket,
        });
        this.handleSdkInit();
        this.switchSdk(adConfig);
      } catch (error) {
        console.error(error);
      }
    });
  }

  public componentWillUnmount(): void {
    clearTimeout(this.loadRenderTimeout);
    clearInterval(this.loadRenderInterval);
    this.adStartTime = 0;
    this.loadRenderTimeout = undefined;
    this.loadRenderInterval = undefined;
    this.hasTracked = false;
  }

  public render(): ReactNode {
    const classesRoot: string = classNames('cmp-advertising', this.props.className);
    const { config, type } = this.props;
    const {willShow} = this.state;
    if (!process.env.BROWSER || !willShow) {return <div className="gg-plh"></div>; }  // 广告-placeholder

    if (process.env.BROWSER) {
      console.log('​render -> config, type', config, type);
    }
    if (!config[type]) {
      console.log('type = undefined', config, type);
      return <div></div>;
    }
    const adConfig = config[type];
    const html = this.renderAdHTML(adConfig);
    // alert(`${type}_${adConfig.adSlot}`)
    return (
        adConfig.adSlot ?  <VisibilitySensor onChange={this.handleOnScreen}>
        <div className={classesRoot} style={this.props.style} data-id={adConfig.adSlot} id={`a-d-${adConfig.adSlot}`} onClick={ this.handleClick }>
          { config.isTest && <div>type: {adConfig.type} adSlotId: {adConfig.adSlot}</div>}
          {html}
        </div>
      </VisibilitySensor>: null
    );
  }

}
